import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { LogOut, Wrench, Users, Building2, LayoutDashboard } from "lucide-react";
import { Toaster } from "sonner";
import NotificationBell from "../NotificationBell";

const NAV = [
  { to: "/service", label: "Dashboard", icon: LayoutDashboard, exact: true },
  { to: "/service/tickets", label: "Service Tickets", icon: Wrench },
  { to: "/service/technicians", label: "Technicians", icon: Users },
];

export default function ServiceTeamLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <div className="min-h-screen bg-[#F4F6F1] flex">
      {/* Sidebar */}
      <aside className="w-56 bg-[#0E2818] text-white flex flex-col fixed h-screen">
        <div className="px-5 py-5 border-b border-[#1F4E2C] flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 bg-[#7DD181] flex items-center justify-center">
              <Building2 className="w-5 h-5 text-[#0E2818]" />
            </div>
            <div>
              <div className="font-display font-bold leading-none">Service Portal</div>
              <div className="font-mono text-[9px] uppercase tracking-[0.25em] text-[#7DD181] mt-0.5">Purvodaya Solar</div>
            </div>
          </div>
        </div>

        <nav className="flex-1 overflow-y-auto py-3">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.exact}
              data-testid={`service-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                "flex items-center gap-2.5 px-5 py-2.5 text-xs font-mono uppercase tracking-widest transition-colors " +
                (isActive
                  ? "bg-[#1F4E2C] text-[#D4FF7A] border-l-2 border-[#D4FF7A]"
                  : "text-white/70 hover:text-white hover:bg-[#1F4E2C]/40 border-l-2 border-transparent")
              }
            >
              <n.icon className="w-3.5 h-3.5" /> {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="px-5 py-4 border-t border-[#1F4E2C]">
          <div className="font-mono text-[10px] uppercase tracking-widest text-[#7DD181]">{user?.role === "service_team" ? "Service Incharge" : user?.role}</div>
          <div className="text-xs text-white mt-0.5 truncate" title={user?.name}>{user?.name}</div>
          <button onClick={() => { logout(); nav("/login"); }} className="mt-2 inline-flex items-center gap-1.5 text-[10px] font-mono uppercase tracking-widest text-white/60 hover:text-white">
            <LogOut className="w-3 h-3" /> Sign out
          </button>
        </div>
      </aside>

      <main className="flex-1 ml-56 p-6 max-w-[1600px]">
        <div className="flex justify-end mb-2">
          <NotificationBell />
        </div>
        <Outlet />
      </main>
      <Toaster position="top-right" richColors />
    </div>
  );
}
